import { render, staticRenderFns } from "./PelatihanEvaluasiPascaKegiatan.vue?vue&type=template&id=32aae5f8"
import script from "./PelatihanEvaluasiPascaKegiatan.vue?vue&type=script&lang=js"
export * from "./PelatihanEvaluasiPascaKegiatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports